import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { countryCodes } from '../data/countryCodes';

const CountryCodePicker = ({ selectedCode, onCodeChange }) => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  const sortedCountries = useMemo(() => {
    return [...countryCodes].sort((a, b) =>
      t(a.nameKey).localeCompare(t(b.nameKey), i18n.language)
    );
  }, [i18n.language, t]);

  const filteredCountries = useMemo(() => {
    if (!searchTerm) return sortedCountries;
    return sortedCountries.filter(country =>
      t(country.nameKey).toLowerCase().includes(searchTerm.toLowerCase()) ||
      country.dial_code.includes(searchTerm) ||
      country.code.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, sortedCountries, t]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    onCodeChange(code);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="country-code-picker" ref={dropdownRef}>
      <div className="picker-toggle" onClick={() => setIsOpen(!isOpen)}>
        {/* DEĞİŞİKLİK: Seçili değer artık sadece telefon kodunu gösteriyor */}
        <span>{selectedCode}</span>
        <i className={`fas fa-chevron-up picker-arrow ${isOpen ? 'open' : ''}`}></i>
      </div>
      {isOpen && (
        <div className="picker-dropdown">
          <div className="picker-search">
            <i className="fas fa-search search-icon"></i>
            <input
              type="text"
              placeholder={t('search_country_code', 'Ara...')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
          <ul className="picker-list">
            {filteredCountries.length > 0 ? (
              filteredCountries.map(country => (
                <li
                  key={country.code}
                  onClick={() => handleSelect(country.dial_code)}
                  className={selectedCode === country.dial_code ? 'active' : ''}
                >
                  {/* DEĞİŞİKLİK: Bayrak için artık emoji yerine CSS sınıfı kullanılıyor */}
                  <span className={`fi fi-${country.code.toLowerCase()} picker-flag`}></span>
                  <span className="picker-country-code">{country.code}</span>
                  <span className="picker-country-name">{t(country.nameKey)}</span>
                  <span className="picker-dial-code">{country.dial_code}</span>
                </li>
              ))
            ) : (
              <li className="no-results">{t('no_results_found')}</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CountryCodePicker;